
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M406.017 200.531c-39.086-39.632-91.24-61.909-146.854-62.729-56.189-.848-109.459 20.404-149.956 59.79-40.459 39.349-63.146 91.93-63.88 148.06-.395 30.135 5.443 59.311 17.352 86.715 11.489 26.438 28.011 49.892 49.11 69.707l.001.001c6.816 6.4 15.71 9.925 25.045 9.925h238.332c9.332 0 18.21-3.511 24.999-9.884 20.777-19.501 37.132-42.55 48.611-68.507 11.888-26.879 17.915-55.524 17.915-85.14-.001-55.726-21.548-108.265-60.675-147.938zM302.723 378.995h-93.445c-8.284 0-15-6.716-15-15s6.716-15 15-15h93.445c8.284 0 15 6.716 15 15s-6.716 15-15 15zm30-55.879H179.277c-8.284 0-15-6.716-15-15s6.716-15 15-15h153.445c8.284 0 15 6.716 15 15s-6.715 15-14.999 15z"}}),_c('path',{attrs:{"d":"M91.41 173.12c21.06-19.8 45.02-35.39 70.84-46.36l-4.88-24.7c-1.57-7.97 1.9-13.67 4.12-16.36 2.21-2.7 7.13-7.21 15.25-7.21h158.52c8.12 0 13.04 4.51 15.25 7.21 2.22 2.69 5.69 8.39 4.12 16.36l-4.86 24.61c25.91 10.95 49.88 26.51 70.87 46.22l10.99-55.62c5.71-28.94-1.75-58.61-20.48-81.41C392.42 13.07 364.76 0 335.26 0H176.74c-29.5 0-57.16 13.07-75.89 35.86-18.73 22.8-26.19 52.47-20.48 81.41z"}})])
          )
        }
      }
    